import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAllSides: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAllSides"><Path d="M6.5 6.5L17.5 6.5L17.5 17.5H6.5L6.5 6.5Z" stroke="currentColor"/><Path d="M20.5 6C20.5 11.4673 20.5 12.5327 20.5 18" stroke="currentColor"/><Path d="M3.5 6C3.5 11.4673 3.5 12.5327 3.5 18" stroke="currentColor"/><Path d="M18 3.5L5.99999 3.5" stroke="currentColor"/><Path d="M18 20.5L5.99999 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutAllSides;
